import {
  Pipe,
  PipeTransform,
  inject,
} from '@angular/core';
import {AppTranslateService} from '../../services/infrastructure/page/i18n/translate/app-translate/app-translate.service';
import {ITranslatableString} from '../../models/base.model';
import {Language} from '../../common/enums/language.enum';

@Pipe({
  name: 'translatableStringData',
})
export class TranslatableStringDataPipe implements PipeTransform {

  private appTranslateService: AppTranslateService = inject(AppTranslateService);

  transform(value: ITranslatableString): string {
    const lang: string = this.appTranslateService.getCurrentAppLanguage() || Language.de;
    return value?.[lang] || '';
  }

}
